import {
  useWSModal,
  WSActions,
  WSElement,
  WSInfoBox,
  WSList,
  WSPillProps,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSText
} from "@wingspanhq/fe-component-library";

interface StatusItem {
  pill: WSPillProps;
  description: string;
  secondaryText: string | undefined;
}

const RequirementsStatusesInfo: React.FC<{
  onClose(): void;
}> = ({ onClose, ...elementProps }) => {
  const statusItems: StatusItem[] = [
    {
      pill: {
        icon: "alert",
        theme: "warning",
        text: "Action required"
      },
      secondaryText: "Awaiting your completion",
      description:
        "Your action is required.\n(Not started or re-requested by client)"
    },
    {
      pill: {
        icon: "time",
        theme: "neutral",
        text: "Awaiting client"
      },
      secondaryText: "Awaiting client approval",
      description:
        "Awaiting client review and approval.\nNo action required at the moment."
    },
    {
      pill: {
        icon: "time",
        theme: "neutral",
        text: "Processing"
      },
      secondaryText: "Awaiting results",
      description:
        "System is processing and generating results.\nNo action required at the moment."
    },
    {
      pill: {
        icon: "check-circle",
        theme: "success",
        text: "Complete"
      },
      secondaryText: undefined,
      description: "Requirement is complete.\n(Including client approval)"
    },
    {
      pill: {
        icon: "alert-circle",
        theme: "error",
        text: "Rejected"
      },
      secondaryText: "Rejected by client",
      description:
        "The client rejected the submission with no re-request. Requirement remains incomplete."
    }
  ];

  const tableData = statusItems.map((item, index) => ({
    id: index.toString(),
    data: item
  }));

  const columns: Array<WSTableColumn<StatusItem>> = [
    {
      config: {
        gridTemplateSizeMax: "1fr"
      },
      renderFunction: ({ data }) => (
        <WSElement py="L">
          <WSTableCell pill={data.pill} secondaryText={data.secondaryText} />
        </WSElement>
      )
    },
    {
      config: {
        gridTemplateSizeMax: "1fr"
      },
      renderFunction: ({ data }) => (
        <WSText.ParagraphSm>{data.description}</WSText.ParagraphSm>
      )
    }
  ];

  return (
    <WSElement {...elementProps}>
      <WSList gap="L">
        <WSTable
          showVerticalDivider
          showHeader={false}
          tableData={tableData}
          columns={columns}
        />

        <WSInfoBox>
          Note: These are statuses that could appear across different
          requirement types. Not all statuses will apply to every requirement.
        </WSInfoBox>
        <WSActions
          alignment="fill"
          buttons={[
            {
              name: "cancel",
              type: "button",
              kind: "Secondary",
              label: "Done",
              onClick: onClose
            }
          ]}
        />
      </WSList>
    </WSElement>
  );
};

export const useModalRequirementsStatusesInfo = () =>
  useWSModal(RequirementsStatusesInfo, {
    title: "Requirement statuses",
    size: "M"
  });
